import { useMemo } from 'react'
import { useTranslate } from 'react-polyglot'
import {
  BILLING_ROUTE,
  DEVICES_ROUTE,
  DIGITAL_WORKFORCE_ROUTE,
  GTC_BILLING_ROUTE,
  PEOPLE_ROUTE,
  PHONES_ROUTE,
  PLACES_ROUTE,
  SETTINGS_ROUTE,
} from '@ucc/unified-admin-common'

import { HOME_KEY } from 'utils/constants'

const useSidebarTitle = (selectedTab: string): string => {
  const t = useTranslate()

  const sidebarTitle = useMemo(() => {
    switch (selectedTab) {
      case HOME_KEY:
        return t('Home')
      case PEOPLE_ROUTE:
        return t('People')
      case DEVICES_ROUTE:
        return t('Devices')
      case PLACES_ROUTE:
        return t('Locations')
      case PHONES_ROUTE:
        return t('Phone system')
      case BILLING_ROUTE:
      case GTC_BILLING_ROUTE:
        return t('Billing')
      case SETTINGS_ROUTE:
        return t('Settings')
      case DIGITAL_WORKFORCE_ROUTE:
        return t('Digital Workforce')
      default:
        return (selectedTab.charAt(0).toUpperCase() + selectedTab.slice(1)).replace('-', ' ')
    }
  }, [selectedTab, t])

  return sidebarTitle
}

export default useSidebarTitle
